import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './Footer.css';

export const Footer = () => {
  const { i18n } = useTranslation();
  const isGerman = i18n.language === 'de';

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>MPG Versandzentrum</h3>
            <p>
              {isGerman
                ? 'Ihr zuverlässiger Partner für Versandadressverwaltung'
                : 'Your reliable partner for shipping address management'
              }
            </p>
          </div>
          
          <div className="footer-section">
            <h4>{isGerman ? 'Rechtliches' : 'Legal'}</h4>
            <ul>
              <li>
                <Link to="/privacy">
                  {isGerman ? 'Datenschutzerklärung' : 'Privacy Policy'}
                </Link>
              </li>
              <li>
                <Link to="/impressum">
                  {isGerman ? 'Impressum' : 'Imprint'}
                </Link>
              </li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4>{isGerman ? 'Kontakt' : 'Contact'}</h4>
            <p>info@alberto.at</p>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} MPG Versandzentrum. {isGerman ? 'Alle Rechte vorbehalten.' : 'All rights reserved.'}</p>
        </div>
      </div>
    </footer>
  );
};
